query ($original: String!, $homeLanguageId: ID!) {
  translation(original: $original, homeLanguageId: $homeLanguageId) {
    translation
  }
}
